<template>
    <v-btn id="reset-scene-button"
           ref="reset-scene-button"
           v-tippy
           content="Reset All"
           :disabled="isDisabled"
           @click="onClick"
    >

        <v-icon class="material-icons"> invert_colors_off </v-icon>
    </v-btn>

</template>

<script>
import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    mounted() {
        this.$root.$refs.resetSceneButton = this.$refs['reset-scene-button'];
    },

    computed: {
        ...mapState('Projects', ['image']),
        ...mapState("App", ["IDT", "blockLoading"]),
        isDisabled() {
            return !this.image || this.IDT.initial || !this.canUseColorGradingTools || this.blockLoading ;
        }
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;
            window.UI.showModal(window.UI.modals.resetScene.el);
        }
    }
}
</script>